import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import CaregiverContactInfoDescription from '../../../components/FormDescriptions/CaregiverContactInfoDescription';
import { emailUI, phoneUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-two-info-title--contact'];
const INPUT_LABEL = content['secondary-two-input-label'];

const { email, phone } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(
      TITLE_TEXT,
      CaregiverContactInfoDescription({ label: INPUT_LABEL }),
    ),
    secondaryTwoPrimaryPhoneNumber: phoneUI(`${INPUT_LABEL} primary`),
    secondaryTwoAlternativePhoneNumber: phoneUI(`${INPUT_LABEL} alternative`),
    secondaryTwoEmail: emailUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['secondaryTwoPrimaryPhoneNumber'],
    properties: {
      secondaryTwoPrimaryPhoneNumber: phone,
      secondaryTwoAlternativePhoneNumber: phone,
      secondaryTwoEmail: email,
    },
  },
};
